class CustomCarouselGridCards extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.swiperContainer = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.swiperContainer = this.querySelector(
      ".custom-carousel-grid-cards__container"
    );
    this.initOrDestroySwiper();
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.destroySwiper();
  }

  handleResize() {
    this.initOrDestroySwiper();
  }

  async initOrDestroySwiper() {
    if (window.innerWidth < 1025) {
      if (!this.swiper) {
        await this.loadSwiperAssets();
        this.initSwiper();
      }
    } else {
      this.destroySwiper();
    }
  }

  async loadSwiperAssets() {
    if (!window.Swiper) {
      if (!document.getElementById("swiper-css")) {
        const link = document.createElement("link");
        link.id = "swiper-css";
        link.rel = "stylesheet";
        link.href =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        document.head.appendChild(link);
      }
      await new Promise((resolve) => {
        if (window.Swiper) return resolve();
        const script = document.createElement("script");
        script.src =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        script.onload = resolve;
        document.body.appendChild(script);
      });
    }
  }

  initSwiper() {
    if (!this.swiperContainer) return;
    this.swiperContainer.classList.add("swiper");
    this.swiperContainer.classList.add("custom-carousel-grid-cards__swiper");
    this.swiperContainer.innerHTML = `
      <div class="swiper-wrapper">
        ${Array.from(this.swiperContainer.children)
          .map((child) => `<div class="swiper-slide">${child.innerHTML}</div>`)
          .join("")}
      </div>
      <div class="swiper-pagination custom-carousel-grid-cards__progressbar"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    `;
    this.swiper = new window.Swiper(this.swiperContainer, {
      slidesPerView: 1.2,
      spaceBetween: 8,
      navigation: {
        nextEl: ".custom-carousel-grid-cards .swiper-button-next",
        prevEl: ".custom-carousel-grid-cards .swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      loop: false,
    });

  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
      if (this.swiperContainer) {
        this.swiperContainer.classList.remove(
          "swiper",
          "custom-carousel-grid-cards__swiper"
        );
        location.reload();
      }
    }
  }
}

customElements.define("custom-carousel-grid-cards", CustomCarouselGridCards);
